import PropTypes from 'prop-types'
import { useState } from 'react'

import useRouterQueryStateArray from 'hooks/useRouterQueryStateArray'

import CheckboxInput from 'components/CheckboxInput'
import Text from 'components/Text'

import { List, Root, TruncateButton } from './ProductsFilterList.style'

const truncateMin = 6

const ProductsFilterList = ({ name, values, columns }) => {
  const [isTruncated, setIsTruncated] = useState(true)
  const shouldTruncate = Array.isArray(values) && values.length > truncateMin
  const showMoreAmount = Array.isArray(values) ? values.length - 6 : 0
  const filterValues = Array.isArray(values) && isTruncated ? values.slice(0, truncateMin) : values

  const { state, push, pop } = useRouterQueryStateArray(name)

  const handleChange = (e) => {
    const { checked, value } = e.target

    checked ? push(value) : pop(value)
  }

  return (
    <Root>
      <List $columns={columns}>
        {filterValues.map((value, index) => {
          const label = value?.formatted || value
          const inputValue = value?.raw || value
          const checked = state?.includes(inputValue) || false

          return (
            <div key={index}>
              <CheckboxInput label={label} value={inputValue} checked={checked} onChange={handleChange} />
            </div>
          )
        })}
      </List>
      {shouldTruncate && (
        <TruncateButton type="button" onClick={() => setIsTruncated(!isTruncated)}>
          <Text>{isTruncated ? `+ Show ${showMoreAmount} more` : '- Show less'}</Text>
        </TruncateButton>
      )}
    </Root>
  )
}

ProductsFilterList.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.array,
  columns: PropTypes.number,
}

ProductsFilterList.defaultProps = {
  values: [],
  columns: 1,
}

export default ProductsFilterList
